export class RollContactDisplayModel {
    contact: string;
    contactName: string;
    rcId: number;
}